import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Settlements from '@/components/Settlements'
import Transactions from '@/components/Transactions'
import Logs from '@/components/Logs'
import Login from '@/components/Login'
import Dummy from '@/components/Dummy'

Vue.use(Router)

export default new Router({
  mode:"history",
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/settlements',
      name: 'Settlements',
      component: Settlements
    },
    {
      path: '/',
      name: 'Transactions',
      component: Transactions
    },
    {
      path: '/logs',
      name: 'Logs',
      component: Logs
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js